var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__scrollbar-hide cz2__color-selector",class:{ 'cz2__is-kiosk': _vm.isKiosk }},[_c('span',{staticClass:"cz2__sr-only"},[_vm._v(" "+_vm._s(_vm.$t('SR_ACTIVATING'))+" ")]),_c('color-selector-swatches',{ref:"swatches",staticClass:"cz2__color-selector-wrapper",attrs:{"colors":_vm.colors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }